"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var promoGrid = typestyle_1.style({
    padding: '10px',
    maxWidth: '72rem',
    margin: '0 auto',
});
var promoSection = typestyle_1.style({
    display: 'grid',
    gridTemplateAreas: "\n      \"header screenshot\"\n      \"text screenshot\"\n    ",
    gridTemplateColumns: '1fr 50%',
    gridTemplateRows: '50% 50%',
    gridRowGap: '5px',
    gridColumnGap: '4rem',
    margin: '40px 0',
    $nest: {
        '&:nth-child(even)': {
            gridTemplateAreas: "\n          \"screenshot header\"\n          \"screenshot text\"\n        ",
        },
        '& > img': {
            gridArea: 'screenshot',
            width: '100%',
            border: '1px solid black',
        },
        '& > h2': {
            margin: 0,
            display: 'flex',
            alignItems: 'flex-end',
        },
        '& > p': {
            marginTop: 0,
        },
    },
}, typestyle_1.media({ maxWidth: '500px' }, {
    display: 'block',
}));
exports.styles = {
    promoGrid: promoGrid,
    promoSection: promoSection,
};
